export default __webpack_public_path__ + "static/map-marker-e9e562e2ccde4e8b4617113836642c50.png";